import { CheckCircle, Close, Info, ReportProblem } from '@mui/icons-material';

import { useEffect, useState } from 'react';
import './alert-message.scss';
/* eslint-disable-next-line */
export interface AlertMessageProps {
  text: string;
  type: 'success' | 'error' | 'warning' | 'info' | 'pending';
  width?: 'full-width' | 'parent-width';
  timeClose?: number;
  handleShowExternaly?: boolean;
  show?: boolean;
  setShow?: (show: boolean) => void;
  handlerOnClickTextLink?: () => void;
  textLink?: string;
  showButtonClose?: boolean;
}

export function AlertMessage({
  text,
  type,
  width = 'full-width',
  timeClose,
  show,
  setShow,
  handleShowExternaly,
  textLink,
  handlerOnClickTextLink,
  showButtonClose = true,
}: AlertMessageProps) {
  const [hidde, setHidde] = useState(false);
  const close = () => {
    setHidde(true);
    if (window.history) {
      window.history.replaceState({}, document.title);
    }
    if (setShow) setShow(false);
  };
  useEffect(() => {
    if (handleShowExternaly) {
      if (show) {
        setHidde(false);
        if (timeClose) {
          const timer = setTimeout(() => close(), timeClose);
        }
      } else setHidde(true);
    }
  }, [show]);

  if (!hidde) {
    return (
      <div className={`alert-message alert-message_${type} ${width}`}>
        {(type == 'info' || type == 'pending') && <Info />}
        {(type == 'error' || type == 'warning') && <ReportProblem />}
        {type == 'success' && <CheckCircle />}
        <p>
          <span dangerouslySetInnerHTML={{ __html: text }} />
          {handlerOnClickTextLink && textLink && (
            <>
              <span onClick={handlerOnClickTextLink} className='text-link'>
                {textLink}
              </span>
              .
            </>
          )}
        </p>
        {showButtonClose && (
          <span className='btn close-button ' onClick={close}>
            <Close />
          </span>
        )}
      </div>
    );
  }
  return <></>;
}

export default AlertMessage;
